import "./style.css";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header, Footer } from "components/Layout";
import alignmentClasses from "utils/landing_page.json";
import LoginModal from "components/Modal/Auth/LoginModal";
import RegisterModal from "components/Modal/Auth/RegisterModal";
import ForgotPasswordModal from "components/Modal/Auth/ForgotPasswordModal";
import VerifyPhoneCodeModal from "components/Modal/Auth/VerifyPhoneCodeModal";
import { useCheckoutReturnModal } from "hooks/useCheckoutReturnModal";

export default () => {
  const { video } = alignmentClasses;
  const location = useLocation();
  useCheckoutReturnModal();
  const displayLocation = location.state?.backgroundLocation || location;
  const pathname = displayLocation.pathname;
  const videoPaths = ["/signup", "/"];
  const shouldDisplayVideo = videoPaths.includes(pathname);
  const heroBackgroundImage =
    pathname === "/"
      ? "url(/images/hero-background.png)"
      : pathname === "/custom-saddle-tree"
        ? "var(--custom-saddle-hero-bg, url(/images/hero-background.png))"
        : "none";

  return (
    <div
      className="hero_sec_img"
      style={{
        backgroundImage: heroBackgroundImage,
        ...(pathname === "/custom-saddle-tree"
          ? {
              backgroundSize: "var(--custom-saddle-hero-bg-size, cover)",
              backgroundPosition:
                "var(--custom-saddle-hero-bg-position, center center)",
              backgroundRepeat: "no-repeat",
            }
          : {}),
      }}
    >
      <div className="video-container">
        {shouldDisplayVideo && (
          <video
            preload="metadata"
            autoPlay
            loop
            muted
            playsInline
            className="w-screen"
          >
            <source src={video} type="video/mp4" />
          </video>
        )}
      </div>
      <div className="absolute top-0 !z-10 w-full h-full">
        <Header />
        <Outlet />
        <Footer />
      </div>
      <LoginModal />
      <RegisterModal />
      <ForgotPasswordModal />
      <VerifyPhoneCodeModal />
    </div>
  );
};
